const CloseIcon = (props) => {
    return (
        <svg
          width={25}
          height={25}
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#clip0_124_7)" fill="#6E0202">
            <path d="M3.125 22.656a.78.78 0 01-.555-1.336L21.32 2.57a.785.785 0 011.11 1.11L3.68 22.43a.78.78 0 01-.555.226z" />
            <path d="M21.875 22.656a.78.78 0 01-.555-.226L2.57 3.68a.784.784 0 111.11-1.11l18.75 18.75a.782.782 0 01-.555 1.336z" />
          </g>
          <defs>
            <clipPath id="clip0_124_7">
              <path fill="#fff" d="M0 0H25V25H0z" />
            </clipPath>
          </defs>
        </svg>
      )
}

export default CloseIcon